import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Avatar,
  Tooltip,
  Typography,
} from '@material-ui/core';

import {
  availabilityStatusTable,
} from '../../constants/general';

import '../../assets/stylesheets/AvailabilityView.css';

class AvailabilityEmployeeChip extends Component {

  displayToolTip = () => {
    const {
      availability: {
        status
      }
    } = this.props;
    return (
      <>
        <Typography>
          {availabilityStatusTable[status]?.statusText}
        </Typography>
      </>
    )
  }

  onClick = () => {
    const {
      employee: {
        id
      }
    } = this.props;
    window.open(`${window.location.href.replace('availability', `user-profile/${id}`)}`, '_blank');
  }

  render() {
    const {
      employee: {
        name,
        profileImage,
      },
      availability: {
        status
      }
    } = this.props;
    return (
      <Tooltip
        title={this.displayToolTip()}
      >
        <div
          role='button'
          onKeyPress={this.onClick}
          className={`employeeChip ${availabilityStatusTable[status]?.styleClass}`}
          onClick={this.onClick}
          tabIndex={0}
        >
          <Avatar
            className="employeeChipAvatar"
            alt={name}
            src={profileImage}
          />
          <p>{name}</p>
        </div>
      </Tooltip>
    )
  }
}

AvailabilityEmployeeChip.propTypes = {
  availability: PropTypes.shape({
    date: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  employee: PropTypes.shape({
    name: PropTypes.string,
    profileImage: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
}

export default AvailabilityEmployeeChip;
